const segmentRules = [
  {
    name: 'At least one of... (nested or)',
    key: 'or',
    type: 'or',
    inverseSelection: false,
    conditions: [],
    availableFilters: {},
    rules: [],
  },
  {
    name: 'A profile from their company... (company scope)',
    key: 'companyScope',
    type: 'companyScope',
    inverseSelection: false,
    conditions: [],
    availableFilters: {},
    rules: [],
  },
  {
    name: 'Viewed page',
    key: 'viewedPage',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['pageView'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      city: {},
      region: {},
      country: {},
      locale: {},
      campaignId: {},
      campaignTags: {},
      productBlock: {},
      bannerBlock: {},
      emailId: {},
      productId: {},
      textMessageId: {},
      viberMessageId: {},
      utmSource: {},
      utmMedium: {},
      utmCampaign: {},
      pageUrl: {},
      page: {},
      deviceType: {},
      whatsappMessageId: {},
    },
  },
  {
    name: 'Engaged with page',
    key: 'pageEngagement',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['pageEngagement'] }],
    // Attribution/message-id filters are omitted: a pageEngagement event carries
    // only page identity + engagement metrics (no products/campaign attribution).
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      scrollPercent: {},
      activeTimeMs: {},
      city: {},
      region: {},
      country: {},
      locale: {},
      pageUrl: {},
      page: {},
      deviceType: {},
    },
    filters: [{ key: 'scrollPercent' }, { key: 'activeTimeMs' }],
  },
  {
    name: 'Opened survey',
    key: 'openedSurvey',
    type: 'event',
    inverseSelection: false,
    conditions: [
      { field: 'actionClass', conditionType: 'term', values: ['survey'] },
      { field: 'action', conditionType: 'term', values: ['surveyOpen'] },
    ],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      surveys: {},
    },
    filters: [{ key: 'surveys' }],
  },
  {
    name: 'Completed survey',
    key: 'completedSurvey',
    type: 'event',
    inverseSelection: false,
    conditions: [
      { field: 'actionClass', conditionType: 'term', values: ['survey'] },
      { field: 'action', conditionType: 'term', values: ['surveySubmission'] },
    ],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      surveys: {},
    },
    filters: [{ key: 'surveys' }],
  },
  {
    name: 'Viewed product',
    key: 'viewedProduct',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['productView'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      price: {},
      discount: {},
      discountPercent: {},
      categories: {},
      city: {},
      region: {},
      country: {},
      locale: {},
      campaignId: {},
      campaignTags: {},
      productBlock: {},
      bannerBlock: {},
      emailId: {},
      productId: {},
      textMessageId: {},
      viberMessageId: {},
      utmSource: {},
      utmMedium: {},
      utmCampaign: {},
      deviceType: {},
      availability: {},
      whatsappMessageId: {},
    },
  },
  {
    name: 'Clicked banner block',
    key: 'bannerClick',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['bannerClick'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      city: {},
      region: {},
      country: {},
      locale: {},
      campaignId: {},
      campaignTags: {},
      bannerBlock: {},
      productId: {},
      utmSource: {},
      utmMedium: {},
      utmCampaign: {},
      deviceType: {},
    },
    filters: [{ key: 'bannerBlock' }],
  },
  {
    name: 'Clicked product block',
    key: 'recommenderClick',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['recommenderClick'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      city: {},
      region: {},
      country: {},
      locale: {},
      campaignId: {},
      campaignTags: {},
      productBlock: {},
      productId: {},
      utmSource: {},
      utmMedium: {},
      utmCampaign: {},
      deviceType: {},
    },
    filters: [{ key: 'productBlock' }],
  },
  {
    name: 'Added to wishlist',
    key: 'addedToWishlist',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['wishlistAdd'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      categories: {},
      city: {},
      region: {},
      country: {},
      locale: {},
      campaignId: {},
      campaignTags: {},
      productBlock: {},
      bannerBlock: {},
      emailId: {},
      productId: {},
      pushNotificationId: {},
      textMessageId: {},
      viberMessageId: {},
      utmSource: {},
      utmMedium: {},
      utmCampaign: {},
      deviceType: {},
      whatsappMessageId: {},
    },
  },
  {
    name: 'Removed from wishlist',
    key: 'removedFromWishlist',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['wishlistRemove'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      categories: {},
      city: {},
      region: {},
      country: {},
      locale: {},
      campaignId: {},
      campaignTags: {},
      productBlock: {},
      bannerBlock: {},
      emailId: {},
      productId: {},
      pushNotificationId: {},
      textMessageId: {},
      viberMessageId: {},
      utmSource: {},
      utmMedium: {},
      utmCampaign: {},
      deviceType: {},
      whatsappMessageId: {},
    },
  },
  {
    name: 'Created wishlist',
    key: 'wishlistCreate',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['wishlistCreate'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      categories: {},
      city: {},
      region: {},
      country: {},
      locale: {},
      campaignId: {},
      campaignTags: {},
      productBlock: {},
      bannerBlock: {},
      emailId: {},
      productId: {},
      pushNotificationId: {},
      textMessageId: {},
      viberMessageId: {},
      utmSource: {},
      utmMedium: {},
      utmCampaign: {},
      deviceType: {},
      whatsappMessageId: {},
    },
  },
  {
    name: 'Added to cart',
    key: 'addedToCart',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['cartAdd'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      cartTotal: {},
      categories: {},
      city: {},
      region: {},
      country: {},
      locale: {},
      campaignId: {},
      campaignTags: {},
      productBlock: {},
      bannerBlock: {},
      emailId: {},
      productId: {},
      pushNotificationId: {},
      textMessageId: {},
      viberMessageId: {},
      utmSource: {},
      utmMedium: {},
      utmCampaign: {},
      deviceType: {},
      whatsappMessageId: {},
    },
  },
  {
    name: 'Removed from cart',
    key: 'removedFromCart',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['cartRemove'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      cartTotal: {},
      categories: {},
      city: {},
      region: {},
      country: {},
      locale: {},
      campaignId: {},
      campaignTags: {},
      productBlock: {},
      bannerBlock: {},
      emailId: {},
      productId: {},
      pushNotificationId: {},
      textMessageId: {},
      viberMessageId: {},
      utmSource: {},
      utmMedium: {},
      utmCampaign: {},
      deviceType: {},
      whatsappMessageId: {},
    },
  },
  {
    name: 'Created cart',
    key: 'cartCreate',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['cartCreate'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      cartTotal: {},
      categories: {},
      city: {},
      region: {},
      country: {},
      locale: {},
      campaignId: {},
      campaignTags: {},
      productBlock: {},
      bannerBlock: {},
      emailId: {},
      productId: {},
      pushNotificationId: {},
      textMessageId: {},
      viberMessageId: {},
      utmSource: {},
      utmMedium: {},
      utmCampaign: {},
      deviceType: {},
      whatsappMessageId: {},
    },
  },
  {
    name: 'Updated cart',
    key: 'cartUpdate',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['cartUpdate'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      cartTotal: {},
      categories: {},
      city: {},
      region: {},
      country: {},
      locale: {},
      campaignId: {},
      campaignTags: {},
      productBlock: {},
      bannerBlock: {},
      emailId: {},
      productId: {},
      pushNotificationId: {},
      textMessageId: {},
      viberMessageId: {},
      utmSource: {},
      utmMedium: {},
      utmCampaign: {},
      deviceType: {},
      whatsappMessageId: {},
    },
  },
  {
    name: 'Initiated checkout',
    key: 'checkoutInitiate',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['checkoutInitiate'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      cartTotal: {},
      categories: {},
      city: {},
      region: {},
      country: {},
      locale: {},
      campaignId: {},
      campaignTags: {},
      productBlock: {},
      bannerBlock: {},
      emailId: {},
      productId: {},
      pushNotificationId: {},
      textMessageId: {},
      viberMessageId: {},
      utmSource: {},
      utmMedium: {},
      utmCampaign: {},
      deviceType: {},
      whatsappMessageId: {},
    },
  },
  {
    name: 'Added payment info',
    key: 'addPaymentInfo',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['addPaymentInfo'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      cartTotal: {},
      categories: {},
      city: {},
      region: {},
      country: {},
      locale: {},
      campaignId: {},
      campaignTags: {},
      productBlock: {},
      bannerBlock: {},
      emailId: {},
      productId: {},
      pushNotificationId: {},
      textMessageId: {},
      viberMessageId: {},
      utmSource: {},
      utmMedium: {},
      utmCampaign: {},
      deviceType: {},
      whatsappMessageId: {},
    },
  },
  {
    name: 'Purchased',
    key: 'purchased',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['cartCheckoutSuccess'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      cartTotal: {},
      categories: {},
      city: {},
      region: {},
      country: {},
      campaignId: {},
      campaignTags: {},
      productBlock: {},
      bannerBlock: {},
      emailId: {},
      productId: {},
      pushNotificationId: {},
      textMessageId: {},
      viberMessageId: {},
      utmSource: {},
      utmMedium: {},
      utmCampaign: {},
      orderId: {},
      whatsappMessageId: {},
    },
  },
  {
    name: 'Refunded',
    key: 'refund',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['refund'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      cartTotal: {},
      categories: {},
      productId: {},
      orderId: {},
    },
  },
  {
    name: 'Order status changed',
    key: 'orderStatusChanged',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['orderStatusChanged'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      orderId: {},
    },
  },
  {
    name: 'Sent email',
    key: 'sentEmail',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['emailSend'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      emailId: {},
      productId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'emailId' }],
  },
  {
    name: 'Delivered email',
    key: 'deliveredEmail',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['emailDelivery'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      emailId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'emailId' }],
  },
  {
    name: 'Opened email',
    key: 'openedEmail',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['emailOpen'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      emailId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'emailId' }],
  },
  {
    name: 'Clicked email',
    key: 'clickedEmail',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['emailClick'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      emailId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'emailId' }],
  },
  {
    name: 'Email bounced',
    key: 'bouncedEmail',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['emailBounce'] }],
    availableFilters: {
      count: {},
      tags: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      emailId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'emailId' }],
  },
  {
    name: 'Email complaint',
    key: 'emailComplaint',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['emailComplaint'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      emailId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'emailId' }],
  },
  {
    name: 'Email rescheduled',
    key: 'emailReschedule',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['emailReschedule'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      emailId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'emailId' }],
  },
  {
    name: 'Email skipped',
    key: 'emailSkip',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['emailSkip'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      emailId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'emailId' }],
  },
  {
    name: 'Sent push notification',
    key: 'sentPush',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['pushNotificationSend'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      pushNotificationId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'pushNotificationId' }],
  },
  {
    name: 'Delivered push notification',
    key: 'deliveredPush',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['pushNotificationDelivery'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      pushNotificationId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'pushNotificationId' }],
  },
  {
    name: 'Clicked push notification',
    key: 'clickedPush',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['pushNotificationClick'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      pushNotificationId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'pushNotificationId' }],
  },
  {
    name: 'Push notification bounced',
    key: 'bouncedPush',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['pushNotificationBounce'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      pushNotificationId: {},
      campaignId: {},
      campaignTags: {},
    },
  },
  {
    name: 'Subscribed to push notifications',
    key: 'pushNotificationSubscribe',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['pushNotificationSubscribe'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
    },
  },
  {
    name: 'Sent text message',
    key: 'sentTextMessage',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['textMessageSend'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      textMessageId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'textMessageId' }],
  },
  {
    name: 'Clicked text message',
    key: 'clickedTextMessage',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['textMessageClick'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      textMessageId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'textMessageId' }],
  },
  {
    name: 'Sent viber message',
    key: 'sentViberMessage',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['viberMessageSend'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      viberMessageId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'viberMessageId' }],
  },
  {
    name: 'Viber message bounced',
    key: 'viberMessageBounce',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['viberMessageBounce'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      viberMessageId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'viberMessageId' }],
  },
  {
    name: 'Viber message delivered',
    key: 'viberMessageDelivery',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['viberMessageDelivery'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      viberMessageId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'viberMessageId' }],
  },
  {
    name: 'Clicked viber message',
    key: 'clickedViberMessage',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['viberMessageClick'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      viberMessageId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'viberMessageId' }],
  },
  {
    name: 'Opened viber message',
    key: 'viberMessageOpen',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['viberMessageOpen'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      viberMessageId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'viberMessageId' }],
  },
  {
    name: 'Viber message expired',
    key: 'viberMessageExpired',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['viberMessageExpired'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      viberMessageId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'viberMessageId' }],
  },
  {
    name: 'Targeted by campaign',
    key: 'targetedByCampaign',
    type: 'event',
    inverseSelection: false,
    conditions: [
      {
        field: 'action',
        conditionType: 'term',
        values: [
          'emailSend',
          'pushNotificationSend',
          'textMessageSend',
          'viberMessageSend',
          'whatsappMessageSend',
          'webhookSend',
          'facebookAdSend',
        ],
      },
    ],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'campaignId' }],
  },
  {
    name: 'Interacted with campaign',
    key: 'interactedWithCampaign',
    type: 'event',
    inverseSelection: false,
    conditions: [
      {
        field: 'action',
        conditionType: 'term',
        values: [
          'emailClick',
          'pushNotificationClick',
          'textMessageClick',
          'viberMessageClick',
          'whatsappMessageClick',
        ],
      },
    ],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'campaignId' }],
  },
  {
    name: 'Entered campaign',
    key: 'campaignEnter',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['campaignEnter'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'campaignId' }],
  },
  {
    name: 'Entered campaign branch',
    key: 'campaignSplitEnter',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['campaignSplitEnter'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'campaignId' }],
  },
  {
    name: 'Performed search',
    key: 'search',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['search'] }],
    availableFilters: {
      count: {},
      locale: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      eventTags: {},
    },
  },
  {
    name: 'Searched as you type',
    key: 'autocompleteInteraction',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['autocompleteInteraction'] }],
    availableFilters: {
      count: {},
      productId: {},
      city: {},
      region: {},
      country: {},
      locale: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      eventTags: {},
      availability: {},
    },
  },
  {
    // No productId or availability filter: products[] on this event carries the sales
    // agent's id, not the product clicked - that is on the productView event at the same
    // timestamp.
    name: 'Clicked a product the sales agent recommended',
    key: 'salesAgentProductClick',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['salesAgentProductClick'] }],
    availableFilters: {
      count: {},
      city: {},
      region: {},
      country: {},
      locale: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      eventTags: {},
    },
  },
  // Not offered as a rule of its own: customActionRules replaces this entry with one
  // "Performed action: <event>" rule per custom event the domain emits, so the action is
  // picked from the rule list rather than by adding an "Action name" filter to a rule
  // that matches nothing until you do. It stays here to hold the shared filter set and to
  // keep the generated rules in this spot in the dropdown order.
  //
  // Segments saved while it was offered directly still carry it verbatim - name,
  // conditions and filters are stored with the segment - and keep rendering and
  // evaluating, so the `action` entry in behaviorRuleFilters and the `customAction` icon
  // in Rules have to stay.
  {
    name: 'Performed custom action',
    key: 'customAction',
    type: 'event',
    inverseSelection: false,
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      productId: {},
      city: {},
      region: {},
      country: {},
      action: {},
      locale: {},
      eventTags: {},
      availability: {},
    },
  },
  {
    name: 'Profile Attributes',
    key: 'profileAttributes',
    type: 'profile',
    inverseSelection: false,
    availableFilters: {
      firstName: {},
      lastName: {},
      tags: {},
      subscriptions: {},
      group: {},
      daysUntilBirthday: {},
      consent: {},
      recencyScore: {},
      frequencyScore: {},
      lifeTimeValue: {},
      observedLifeTimeValue: {},
      monetaryScore: {},
      churnProbabilityScore: {},
      retargetPredictionScore: {},
      hasEmail: {},
      hasPhoneNumber: {},
      emailDomain: {},
    },
  },
  {
    name: 'Registered',
    key: 'profileRegistered',
    type: 'profile',
    inverseSelection: false,
    conditions: [{ field: 'registeredAt', conditionType: 'exists' }],
    availableFilters: {
      absoluteTimeframe: { field: 'registeredAt' },
      relativeTimeframe: { field: 'registeredAt' },
      relativeTimeframeHours: { field: 'registeredAt' },
    },
  },
  {
    // Distinct from the `profileRegistered` rule above, which tests the profile column:
    // this one matches the registration event, so it can be filtered by attribution.
    name: 'Completed registration',
    key: 'register',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['register'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      city: {},
      region: {},
      country: {},
      locale: {},
      // The `products.*` filters on this rule are limited to the five keys the
      // `attributions` object of POST /api/v0/subscribe accepts: a `register` event's
      // `products[]` is an attribution envelope rather than product data, and that
      // endpoint is the only writer that fills it. utm*, campaignTags and
      // pushNotificationId were offered here and could never match.
      campaignId: {},
      emailId: {},
      textMessageId: {},
      viberMessageId: {},
      deviceType: {},
      whatsappMessageId: {},
    },
  },
  {
    name: 'Subscribed',
    key: 'profileSubscribed',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['subscribe'] }],
    availableFilters: {
      // event-based rule: timeframes keep the default events.timestamp field,
      // subscribedAt only exists on profiles
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      // `subscriptions` is a profiles column, and this rule is matched against events:
      // the subscribe event records the subscriptions it added as a custom string entry,
      // so address it through that. Left as the bare column the identifier resolves to
      // the enclosing `FROM profiles`, which ClickHouse rejects as a correlated subquery.
      subscriptions: { field: 'custom.string.subscriptions' },
    },
  },
  {
    name: 'Subscriptions Changed',
    key: 'profileSubscriptionsChanged',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['subscriptionsChanged'] }],
    availableFilters: {
      absoluteTimeframe: { field: 'timestamp' },
      relativeTimeframe: { field: 'timestamp' },
      relativeTimeframeHours: { field: 'timestamp' },
      // Same as the Subscribed rule above: an event, so read the custom string entry.
      subscriptions: { field: 'custom.string.subscriptions' },
    },
  },
  {
    // No `subscriptions` filter: unlike the two rules above there is no evidence the
    // request event records the requested list as a custom string entry, and the bare
    // profiles column is the correlated-subquery trap described there.
    name: 'Submitted subscribe request',
    key: 'subscribeRequest',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['subscribeRequest'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
    },
  },
  {
    name: 'Unsubscribed',
    key: 'unsubscribed',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['unsubscribe'] }],
    availableFilters: {
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      emailId: {},
      textMessageId: {},
      viberMessageId: {},
      pushNotificationId: {},
      campaignId: {},
      campaignTags: {},
      whatsappMessageId: {},
    },
  },
  {
    name: 'UTM Interactions',
    key: 'utmInteraction',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['utmSessionStart'] }],
    availableFilters: {
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      utmSource: {},
      utmMedium: {},
      utmCampaign: {},
      locale: {},
      deviceType: {},
    },
  },
  {
    name: 'Current Shipment Status',
    key: 'currentShipmentStatus',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['cartCheckoutSuccess'] }],
    availableFilters: {
      orderId: {},
      shipmentStatus: {},
    },
  },
  {
    name: 'Belongs to Segment',
    key: 'belongsToSegment',
    type: 'segment',
    inverseSelection: false,
    conditions: [{ conditionType: 'segment' }],
    availableFilters: {
      segmentId: {},
    },
  },
  {
    name: 'Sent whatsapp message',
    key: 'sentWhatsappMessage',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['whatsappMessageSend'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      whatsappMessageId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'whatsappMessageId' }],
  },
  {
    name: 'Whatsapp message bounced',
    key: 'whatsappMessageBounce',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['whatsappMessageBounce'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      whatsappMessageId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'whatsappMessageId' }],
  },
  {
    name: 'Whatsapp message delivered',
    key: 'whatsappMessageDelivery',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['whatsappMessageDelivery'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      whatsappMessageId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'whatsappMessageId' }],
  },
  {
    name: 'Clicked whatsapp message',
    key: 'clickedWhatsappMessage',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['whatsappMessageClick'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      whatsappMessageId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'whatsappMessageId' }],
  },
  {
    name: 'Opened whatsapp message',
    key: 'openedWhatsappMessage',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['whatsappMessageOpen'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      whatsappMessageId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'whatsappMessageId' }],
  },
  {
    name: 'Whatsapp message deleted',
    key: 'whatsappMessageDeleted',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['whatsappMessageDeleted'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      whatsappMessageId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'whatsappMessageId' }],
  },
  {
    name: 'Webhook opened',
    key: 'webhookOpened',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['webhookOpen'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      webhookId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'webhookId' }],
  },
  {
    name: 'Webhook clicked',
    key: 'webhookClicked',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['webhookClick'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      webhookId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'webhookId' }],
  },
  {
    name: 'Webhook bounced',
    key: 'webhookBounced',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['webhookBounce'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      webhookId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'webhookId' }],
  },
  {
    name: 'Webhook sent',
    key: 'webhookSent',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['webhookSend'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      webhookId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'webhookId' }],
  },
  {
    name: 'Webhook delivered',
    key: 'webhookDelivered',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['webhookDelivered'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      webhookId: {},
      campaignId: {},
      campaignTags: {},
    },
    filters: [{ key: 'webhookId' }],
  },
  {
    name: 'Earned loyalty points',
    key: 'loyaltyGrant',
    type: 'event',
    inverseSelection: false,
    conditions: [
      { field: 'actionClass', conditionType: 'term', values: ['loyalty'] },
      { field: 'action', conditionType: 'term', values: ['loyaltyGrant'] },
      { field: 'custom.date.expiry', conditionType: 'absoluteTimeRange', values: ['now()', null] },
    ],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      totalLoyaltyPoints: {},
    },
    filters: [{ key: 'totalLoyaltyPoints' }],
  },
  {
    name: 'Redeemed loyalty points',
    key: 'loyaltyPurchase',
    type: 'event',
    inverseSelection: false,
    conditions: [
      { field: 'actionClass', conditionType: 'term', values: ['loyalty'] },
      { field: 'action', conditionType: 'term', values: ['loyaltyPurchase'] },
    ],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
      totalLoyaltyPointsRedeemed: {},
    },
  },
  {
    name: 'Purchased loyalty coupon',
    key: 'loyaltyCouponPurchase',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['loyaltyCouponPurchase'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
    },
  },
  {
    // Internal bookkeeping written when two profiles are merged, so it carries no
    // attribution of its own - count and timeframes are all it can be filtered by.
    name: 'Profile merged',
    key: 'merge',
    type: 'event',
    inverseSelection: false,
    conditions: [{ field: 'action', conditionType: 'term', values: ['merge'] }],
    availableFilters: {
      count: {},
      absoluteTimeframe: {},
      relativeTimeframe: {},
      relativeTimeframeHours: {},
    },
  },
];

export default segmentRules;
